export const locationConstants = {
  UPDATE_DEPLOYMENTS: "UPDATE_DEPLOYMENTS",
  UPDATE_LOCATIONS: "UPDATE_LOCATIONS",
  UPDATE_ORGANISATIONS: "UPDATE_ORGANISATIONS",
  UPDATE_PARTNERS: "UPDATE_PARTNERS",
  UPDATE_MAPS: "UPDATE_MAPS",
  UPDATE_GREENHOUSES: "UPDATE_GREENHOUSES",
};
